module.exports = __webpack_public_path__ + "img/MGTSPL_LOGO.d7385222.png";